module.exports = __webpack_public_path__ + "static/img/skill-valo.3aae5bce.png";